import React, { useEffect, useState  } from 'react';
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
import { Table,Search, IconPlus,Button } from "@veneer/core";
import $ from 'jquery';
import { Col, Row } from "react-bootstrap";
import Consumables from './consumable';
const ConfigConsumables = ( props ) => {
    const connectApi = new ConnectAPI();
    const [fulldata,setfulldata]=useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [partfilter,setpartfilter]=useState("")
    const [descriptionfilter,setdescriptionfilter]=useState("");
    const [typefilter,settypefilter]=useState("");
    const [orderBy, setOrderBy] = useState("idPart");
    const [orderType, setOrderType] = useState("descending");
    const handlePageChange = (page) => setCurrentPage(page);
    const [selectitem,setselectitem]=useState([]);
    const [viewmodal, setviewmodal]=useState(false);
    const [origin,setorigin]=useState("");
    const pageSize = 25;
    const [order, setOrder] = useState([
            'idPart',
            'description',
            'consumableType',
            'actionbutton'
        ]);
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy === "datePrintOs" || orderBy === "dateCOI" || orderBy === "dateCOIConfirm" 
            || orderBy === "dateCreate" || orderBy === "dateLastModify" ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else if ( orderBy === "active" || orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1; 
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        if(orderBy === "activeToogle")
            orderBy = "active";
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    useEffect(()=>{
            //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
          if (ur==window.location.pathname){
            validate=true;
          }
        });
        if (validate==false){
          const { history } = props;
            history.push({
              pathname: '/' 
            });
        }
        //end validate
            start();
    },[]);
    const start=()=>{
            connectApi
            .get("api/Channels/getconsumables","",consolid)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            });
    }
    const consolid = (status, data)=>{
        data.map((x)=>{
            x.actionbutton=(
                <Button >Unconfigured Prices</Button>
            );
        })
        setfulldata(data);
    }
    const filteredData = filterSort(
        fulldata, { 
            idPart: partfilter,
            description: descriptionfilter,
            consumableType: typefilter,
        },
        orderBy,
        orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    function setModalParameters(e){
        var active = $(e.target).closest('tr').children().eq(0).text();
        if(active!="ID Part" && active!=""){
            if(e.target.tagName==='BUTTON'){
                setorigin("pricelist");
            }else{
                setorigin("one");
            }
            let vaItem = fulldata.find(va => va.idPart === active);
            setviewmodal(true);
            setselectitem(vaItem);
        }
    };
    const hideDetailsModal = () => { setviewmodal(false); }
    const successgeneral=(data)=>{  
        start();
        let vaItem = fulldata.find(va => va.idPart === data);
        setselectitem(vaItem);
        setviewmodal(false);
    }
    function addconsumable(){
        setviewmodal(true);
        setorigin("one");
        setselectitem(null);
    }
    function addfile(){
        setviewmodal(true);
        setorigin("file");
        setselectitem(null);
    }
    
    return(<>
    
    
    <Row>
        <Col xs={1}>
            <Button leadingIcon={<IconPlus />}  onClick={addconsumable}>
                Add
            </Button>
        </Col>
        <Col xs={1}>
            <Button leadingIcon={<IconPlus />}  onClick={addfile} appearance="secondary">
                Add File
            </Button>
        </Col>
        <Col></Col>
    </Row>
    <Table
        onClick={ setModalParameters}
        columns={[
            {
            id: 'idPart',
            label: 'ID Part',
            filter: (
                <Search
                    id="parft-filter"
                    value={partfilter}
                    onChange={(val) => {
                        setpartfilter(val);
                        setCurrentPage(1);
                    }}
                />
            )
            },
            {
            id: 'description',
            label: 'Description',
            filter: (
                <Search
                    id="description-filter"
                    value={descriptionfilter}
                    onChange={(val) => {
                        setdescriptionfilter(val);
                        setCurrentPage(1);
                    }}
                />
            )
            },
            {
            id: 'consumableType',
            label: 'Consumable Type',
            filter: (
                <Search
                    id="type-filter"
                    value={typefilter}
                    onChange={(val) => {
                        settypefilter(val);
                        setCurrentPage(1);
                    }}
                />
            )
            },
            {
                id: 'actionbutton',
                label: '',
                
                }
        ]}
        showFilters
        columnReorder
        data={pagedData}
        preferences={{
            defaultOrder: order,
            sortBy: {
                id: orderBy,
                type: orderType,
            },
            order: order
        }}
        pagination={{
            currentPage,
            onPageChange: handlePageChange,
            pageSize,
            totalItems: filteredData.length,
        }}
    />
    <Consumables
        onShowModal={viewmodal} 
        onCloseDetailsModal={hideDetailsModal} 
        consumabledetail={selectitem}
        onsuccessgeneral={successgeneral}
        origin={origin}
    />
    </>);
}
export default ConfigConsumables;